import { getAffectationProduitUnitaireAsync } from '@/api/affectation';
import formatDate from '@/services/general/formatIsoDate';

export default async function loadAffectationOfFaces(faces, dateDebut, dateFin) {
  if (dateDebut === null || dateFin === null) return [];
  const faceList = [];
  faces
    .filter((face) => {
      return face.produitId;
    })
    .forEach((face) => {
      faceList.push({
        id: face.produitId,
        dureeAffectation: {
          dateDebut: formatDate(dateDebut ?? new Date()),
          dateFin: formatDate(dateFin ?? new Date()),
        },
      });
    });
  const affectations = (await getAffectationProduitUnitaireAsync(faceList, false, true))
    .data.result;
  return affectations;
}
